import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Box, Text, Inline } from "braid-design-system";
import clsx from "clsx";
import { useEffect } from "react";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { languages } from "@seek/melways-sites";
import { useChatContext } from "../../EmployerHeader.mjs";
import { root, headerLink, navItem, touchableNavItem, desktopNavItem, isActive, mobileUnreadCount, messageCountRoot, messageCountContainer } from "./ChatHeaderLink.css.mjs";
const getWindowPathWithoutLanguage = () => {
  if (typeof window === "undefined") {
    return "/";
  }
  let path = window.location.pathname;
  const pathArray = path.split("/");
  if (languages.find((language) => language === pathArray[1])) {
    pathArray.splice(1, 1);
    path = pathArray.join("/") || "/";
  }
  return path + window.location.search + window.location.hash;
};
const IconChat = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.91132 3.39077C8.45253 2.48004 10.21 1.99974 12.0001 2L12.0003 2C13.5121 2.00051 15.004 2.34375 16.364 3.00394C17.724 3.66412 18.9166 4.62404 19.8521 5.81154C20.7877 6.99903 21.4418 8.38318 21.7653 9.8599C22.0888 11.3366 22.0733 12.8675 21.72 14.3373C21.3667 15.8072 20.6847 17.1778 19.7253 18.3462C18.7659 19.5145 17.5541 20.4501 16.1811 21.0826C14.808 21.7151 13.3094 22.0281 11.798 21.998C10.4052 21.9703 9.03483 21.6519 7.77438 21.0647L3.19616 21.9806C2.8466 22.0505 2.48626 21.9291 2.25034 21.6618C2.01441 21.3946 1.93859 21.022 2.05132 20.6838L3.30102 16.9347C2.49981 15.5225 2.05326 13.9341 2.00336 12.3064C1.94851 10.5171 2.37501 8.74579 3.23832 7.17753C4.10163 5.60926 5.37011 4.3015 6.91132 3.39077ZM11.9997 4C10.5676 3.99982 9.1617 4.38406 7.92879 5.11262C6.69582 5.8412 5.68104 6.88741 4.99039 8.14202C4.29974 9.39663 3.95854 10.8136 4.00243 12.2451C4.04631 13.6766 4.47365 15.07 5.23985 16.28C5.40054 16.5338 5.43866 16.8463 5.34368 17.1312L4.49363 19.6814L7.71285 19.0374C7.93355 18.9933 8.1627 19.0249 8.36322 19.1271C9.44066 19.6764 10.6286 19.9743 11.8378 19.9984C13.0469 20.0225 14.2458 19.7721 15.3443 19.2661C16.4427 18.7601 17.4121 18.0116 18.1796 17.0769C18.9471 16.1423 19.4927 15.0458 19.7754 13.8699C20.0581 12.694 20.0705 11.4693 19.8116 10.2879C19.5528 9.10654 19.0295 7.99922 18.2811 7.04923C17.5327 6.09924 16.5786 5.33129 15.4906 4.80315C14.4027 4.27503 13.2092 4.00043 11.9999 4",
          fill: "#2E3849"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9 10.5H15",
          stroke: "#2E3849",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M9 14H13", stroke: "#2E3849", strokeWidth: "2", strokeLinecap: "round" })
    ]
  }
);
const chatPath = "/chat";
const analyticsDesktopEvent = {
  eventName: "navigation_pressed",
  actionOrigin: "global header",
  actionPressed: "header - chat",
  entryPoint: "header - chat"
};
const analyticsMobileEvent = {
  eventName: "navigation_pressed",
  actionOrigin: "mobile header",
  actionPressed: "header - chat",
  entryPoint: "header - chat"
};
const handleClick = (analyticsEvent, handleInteractionTracking) => (_event) => {
  if (analyticsEvent) {
    handleInteractionTracking(analyticsEvent);
  }
};
const isChatPage = () => getWindowPathWithoutLanguage().includes("/chat") || getWindowPathWithoutLanguage().includes("on-chat-page");
const MessageCount = (props) => /* @__PURE__ */ jsx(
  Box,
  {
    className: messageCountRoot,
    background: "brandAccent",
    borderRadius: "full",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    children: /* @__PURE__ */ jsx(Box, { alignItems: "center", className: messageCountContainer, children: /* @__PURE__ */ jsx(Text, { size: "xsmall", children: props.unreadMessageCount < 100 ? props.unreadMessageCount : "99+" }) })
  }
);
const ChatIcon = ({ unreadMessageCount, mode }) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Inline, { space: "xxsmall", alignY: "center", children: [
  /* @__PURE__ */ jsxs(Box, { userSelect: "none", cursor: "pointer", position: "relative", children: [
    /* @__PURE__ */ jsx(IconChat, {}),
    unreadMessageCount > 0 && !isChatPage() && /* @__PURE__ */ jsx(MessageCount, { unreadMessageCount })
  ] }),
  /* @__PURE__ */ jsx(
    Text,
    {
      size: "small",
      weight: isChatPage() && mode === "mobile" ? "strong" : "regular",
      children: "Chats"
    }
  )
] }) });
const ChatHeaderDesktopLink = ({
  linkRenderer: LinkRenderer,
  urlResolver,
  ...props
}) => {
  const headerItemLinkClasses = [
    root,
    headerLink,
    navItem,
    touchableNavItem,
    desktopNavItem,
    isChatPage() ? isActive : ""
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const { chatUser } = useChatContext();
  const linkProps = { ...props, className: clsx(headerItemLinkClasses) };
  const trackingEvent = {
    ...analyticsDesktopEvent,
    chatNotificationCount: (chatUser == null ? void 0 : chatUser.unreadMessageCount) ?? 0
  };
  useEffect(() => {
    if (chatUser) {
      handleInteractionTracking({
        eventName: "header_chat_viewed",
        actionOrigin: "global header",
        actionPressed: "",
        chatNotificationCount: chatUser.unreadMessageCount
      });
    }
  }, [chatUser, handleInteractionTracking]);
  return (chatUser && /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      href: urlResolver({ path: chatPath }),
      onClick: handleClick(trackingEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsx(
        ChatIcon,
        {
          mode: "desktop",
          unreadMessageCount: chatUser.unreadMessageCount
        }
      )
    }
  )) ?? /* @__PURE__ */ jsx(Fragment, {});
};
const ChatHeaderMobileLink = ({
  linkRenderer: LinkRenderer,
  urlResolver,
  ...props
}) => {
  const headerItemLinkClasses = [
    headerLink,
    navItem,
    touchableNavItem
  ];
  const { handleInteractionTracking } = useEmployerHeaderContext();
  const linkProps = {
    ...props,
    href: urlResolver({ path: chatPath }),
    className: clsx(headerItemLinkClasses)
  };
  const { chatUser } = useChatContext();
  const trackingEvent = {
    ...analyticsMobileEvent,
    chatNotificationCount: (chatUser == null ? void 0 : chatUser.unreadMessageCount) ?? 0
  };
  return (chatUser && /* @__PURE__ */ jsx(
    LinkRenderer,
    {
      ...linkProps,
      onClick: handleClick(trackingEvent, handleInteractionTracking),
      children: /* @__PURE__ */ jsx(
        ChatIcon,
        {
          mode: "mobile",
          unreadMessageCount: chatUser.unreadMessageCount
        }
      )
    }
  )) ?? /* @__PURE__ */ jsx(Fragment, {});
};
const ChatHeaderMobileUnreadCount = () => {
  const { chatUser } = useChatContext();
  return /* @__PURE__ */ jsx(Fragment, { children: chatUser && chatUser.unreadMessageCount > 0 && !isChatPage() ? /* @__PURE__ */ jsx(
    Box,
    {
      background: "brandAccent",
      borderRadius: "full",
      marginRight: "none",
      className: mobileUnreadCount,
      style: {
        padding: "4px"
      },
      children: /* @__PURE__ */ jsx(Text, { size: "xsmall", children: chatUser.unreadMessageCount })
    }
  ) : null });
};
export {
  ChatHeaderDesktopLink,
  ChatHeaderMobileLink,
  ChatHeaderMobileUnreadCount,
  getWindowPathWithoutLanguage
};
